"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolInteractionEngine = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const toolbox_1 = require("@streem/toolbox");
class ToolInteractionEngine {
    constructor(roomSession) {
        this.roomSession = roomSession;
        this.active = false;
    }
    handleMouseInteractionEvent(evt, tool) {
        (0, toolbox_1.invariant)(tool === 'LASER' || tool === 'MARKER', 'ToolInteractionEngine can only handle LASER and MARKER tools');
        if (evt.buttons.primary && evt.inFrame) {
            this.active = true;
            this.roomSession.tools.updateTool(tool, streem_sdk_protobuf_1.streem.room.ToolEventType.TOOL_EVENT_TYPE_MOVE, {
                xPercent: evt.xPercent * 100,
                yPercent: evt.yPercent * 100,
            });
        }
        else if ((!evt.buttons.primary || !evt.inFrame) && this.active) {
            this.active = false;
            this.roomSession.tools.updateTool(tool, streem_sdk_protobuf_1.streem.room.ToolEventType.TOOL_EVENT_TYPE_HIDE);
        }
    }
}
exports.ToolInteractionEngine = ToolInteractionEngine;
//# sourceMappingURL=tool_interaction_engine.js.map